var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "dark-theme",
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "교육 · 법률지원",
            "src": "/images/sub/sub-visual-education.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_vm.application ? _c('div', [_c('div', {
    staticClass: "mb-20px mb-md-30px mb-lg-40px",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "font-size-20 font-size-md-30 font-size-lg-36 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.application.subject))])]), _c('v-divider', {
    staticClass: "grey darken-4",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _vm._l(_vm.application.items, function (item, index) {
    return [_c('v-row', {
      key: index,
      staticClass: "font-size-14 font-size-md-16 font-weight-regular font-pretendard",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-layout', {
      staticClass: "grey lighten-5 w-100 h-100 px-12px py-8px px-md-20px py-md-24px w-md-160px",
      attrs: {
        "align-center": ""
      }
    }, [_c('span', {
      staticClass: "font-weight-medium grey--text text--darken-4",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
      }
    })])], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": ""
      }
    }, [_c('v-layout', {
      staticClass: "grey--text w-100 h-100 px-12px py-8px px-md-20px py-md-24px",
      attrs: {
        "align-center": ""
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
      }
    })])], 1)], 1), _c('v-divider', {
      key: index
    })];
  }), _c('div', {
    staticClass: "mt-40px mt-md-50px text-center"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-180px justify-space-between",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "secondary",
      "href": "#application-content"
    }
  }, [_vm._v(" 상세보기 "), _c('icon-arrow-rounded', {
    staticClass: "icon--size-small ml-12px",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "800",
      "content-class": "rounded-0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "min-w-lg-180px justify-space-between",
          attrs: {
            "x-large": "",
            "outlined": "",
            "color": "secondary"
          }
        }, on), [_vm._v(" 문의처 "), _c('icon-arrow-rounded', {
          staticClass: "icon--size-small ml-12px",
          attrs: {
            "direction": "right"
          }
        })], 1)];
      }
    }, {
      key: "default",
      fn: function fn(dialog) {
        return [_c('v-card', {
          attrs: {
            "tile": "",
            "flat": ""
          }
        }, [_c('v-toolbar', {
          attrs: {
            "tile": "",
            "flat": ""
          }
        }, [_c('v-spacer'), _c('v-toolbar-title', {
          staticClass: "font-size-18 font-weight-extrabold line-height-11 ml-24px d-md-none"
        }, [_vm._v("문의처")]), _c('v-spacer'), _c('v-btn', {
          staticClass: "transparent",
          attrs: {
            "x-large": "",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              dialog.value = false;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey darken-4",
            "size": "24"
          }
        }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
          staticClass: "px-30px pb-30px px-md-50px pt-md-10px pb-md-50px px-lg-60px pt-lg-12px pb-lg-80px"
        }, [_c('div', {
          staticClass: "mb-30px mb-md-40px d-none d-md-block"
        }, [_c('div', {
          staticClass: "font-size-md-24 font-weight-extrabold line-height-11 text-center"
        }, [_vm._v("문의처")])]), _c('v-divider', {
          staticClass: "grey darken-4",
          staticStyle: {
            "border-width": "2px 0 0"
          }
        }), _vm._l(_vm.application.helpItems, function (item, index) {
          return [_c('v-row', {
            key: index,
            staticClass: "font-size-14 font-size-md-16 font-weight-regular font-pretendard",
            attrs: {
              "no-gutters": ""
            }
          }, [_c('v-col', {
            attrs: {
              "cols": "12",
              "md": "auto"
            }
          }, [_c('v-layout', {
            staticClass: "grey lighten-5 w-100 h-100 px-12px py-8px px-md-20px py-md-24px w-md-160px",
            attrs: {
              "align-center": ""
            }
          }, [_c('span', {
            staticClass: "font-weight-medium grey--text text--darken-4",
            domProps: {
              "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
            }
          })])], 1), _c('v-col', {
            attrs: {
              "cols": "12",
              "md": ""
            }
          }, [_c('v-layout', {
            staticClass: "grey--text w-100 h-100 px-12px py-8px px-md-20px py-md-24px",
            attrs: {
              "align-center": ""
            }
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
            }
          })])], 1)], 1), _c('v-divider', {
            key: index
          })];
        })], 2)], 1)];
      }
    }], null, false, 1741680781)
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-180px justify-space-between",
    attrs: {
      "x-large": "",
      "tile": "",
      "outlined": "",
      "color": "secondary",
      "href": _vm.application.link,
      "target": "_blank"
    }
  }, [_vm._v(" 접수 바로가기 "), _c('icon-arrow-rounded', {
    staticClass: "icon--size-small ml-12px",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "icon": "",
      "tile": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": _vm.copyClipboard
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 18 / 18,
      "max-width": "18",
      "src": "/images/icon/icon-link.svg"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "pt-60px pt-xl-100px",
    attrs: {
      "id": "application-content"
    }
  }, [_c('v-divider', {
    staticClass: "grey darken-4 mb-20px mb-md-32px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.application.content)
    }
  })])], 1)], 2) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }